import { type FormEvent, useState } from 'react'
import { Link, createFileRoute } from '@tanstack/react-router'
import { useMutation } from '@tanstack/react-query'
import { AuthLayout } from '../components/AuthLayout'
import { Button, Field, FormError } from '../components/ui'
import { api, call, messageOf } from '../lib/api'

export const Route = createFileRoute('/forgot')({ component: Forgot })

function Forgot() {
  const [email, setEmail] = useState('')
  const send = useMutation({ mutationFn: () => call(api.POST('/auth/forgot', { body: { email } })) })
  const submit = (e: FormEvent) => {
    e.preventDefault()
    send.mutate()
  }
  if (send.isSuccess) {
    return (
      <AuthLayout title="Check your email" lede={`If ${email} has an account, a reset link is on its way. It works once and lasts an hour.`}
        footer={<Link to="/login" className="font-semibold text-ink underline underline-offset-2">Back to sign in</Link>}>
        <p className="text-[14.5px] text-muted">Nothing after a few minutes? Look in spam, or check you used the address you signed up with.</p>
      </AuthLayout>
    )
  }
  return (
    <AuthLayout title="Forgot your password?" lede="Tell us your email and we'll send a link to choose a new one."
      footer={<Link to="/login" className="font-semibold text-ink underline underline-offset-2">Back to sign in</Link>}>
      <form onSubmit={submit} className="grid gap-4">
        <FormError>{send.isError && messageOf(send.error)}</FormError>
        <Field label="Email" name="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <Button type="submit" variant="primary" block busy={send.isPending}>Send reset link</Button>
      </form>
    </AuthLayout>
  )
}
